"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EncryptionService = void 0;
const CryptoJS = __importStar(require("crypto-js"));
const config_1 = require("../config");
/**
 * Servicio para encriptar datos y redirigir al usuario
 */
class EncryptionService {
    encryptAndRedirect(formData) {
        const encryptedParams = this.encryptData(formData);
        this.redirect(encryptedParams);
    }
    encryptData(params) {
        const secretKey = config_1.config.skey;
        const jsonParams = JSON.stringify(params);
        const key = CryptoJS.enc.Utf8.parse(secretKey);
        const iv = CryptoJS.lib.WordArray.random(16);
        const encrypted = CryptoJS.AES.encrypt(jsonParams, key, {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        }).ciphertext;
        const combined = iv.concat(encrypted);
        return CryptoJS.enc.Base64.stringify(combined);
    }
    /**
     * Redirige en la misma ventana (Bankinter usa location.href)
     */
    redirect(encodedParams) {
        const finalUrl = `${config_1.config.frontendSitesHost}/sites/solar360/singulares/form.html?params=${encodedParams}#step1`;
        window.location.href = finalUrl;
    }
}
exports.EncryptionService = EncryptionService;
